import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Table, Input, InputGroup } from 'reactstrap'
import CreatableSelect from './CreatableSelect'
import RangeInputInfinity from './helpers/RangeInputInfinity'
import BaseMaterialModal from '../Dictionary/BaseMaterialModal'

class WpsBaseMaterialsForm extends Component {

  constructor(props) {
    super(props)
    this.state = {
      base_materials_standardizations_dict: [...new Set(props.base_material_dict.map(obj => obj.standardization))]
        .map(standardization => ({ name: standardization })),
      standardizations: props.value.map(obj => obj.base_material && obj.base_material.standardization),
      base_material_modal_idx: null
    }

    this.handleAddDynamicInput = this.handleAddDynamicInput.bind(this)
    this.handleRemoveDynamicInput = this.handleRemoveDynamicInput.bind(this)
    this.handleValueChangeFunction = this.handleValueChangeFunction.bind(this)
    this.setBaseMaterial = this.setBaseMaterial.bind(this)
    this.renderRows = this.renderRows.bind(this)
  }

  static propTypes = {
    base_material_dict: PropTypes.array,
    product_type_dict: PropTypes.array,
    value: PropTypes.array.isRequired,
    validation_errors: PropTypes.array,
    valueChangeFunction: PropTypes.func.isRequired
  }

  copyInfinity() {
    navigator.clipboard.writeText('∞')
  };

  handleAddDynamicInput() {
    let newValue = this.props.value
    newValue.push({ product_type: {}, thickness: ['0', '0'], throat_thickness: ['0', '0'], diameter: ['0', '0'], base_material: {}, _destroy: null })
    this.props.valueChangeFunction(newValue)
  }

  handleRemoveDynamicInput(idx, presisted) {
    if (presisted) {
      let newValue = this.props.value
      newValue[idx]._destroy = 1
      this.props.valueChangeFunction(newValue)
    } else {
      this.setState({ standardizations: this.state.standardizations.filter((s, sidx) => idx !== sidx) })
      this.props.valueChangeFunction(this.props.value.filter((s, sidx) => idx !== sidx))
    }
  }

  handleValueChangeFunction(idx, inputName) {
    let self = this

    function updateValue(val) {
      let newValue = self.props.value
      newValue[idx][inputName] = val

      self.props.valueChangeFunction(newValue)
    }

    return updateValue
  }

  setBaseMaterial(base_material) {
    let setBaseMaterialFunc = this.handleValueChangeFunction(this.state.base_material_modal_idx, 'base_material')
    setBaseMaterialFunc(base_material)
    this.setState({ base_material_modal_idx: null })
  }

  renderRows() {
    return this.props.value.map((inputRecordData, idx) => {
      const validationErrors = this.props.validation_errors[idx] || {}
      if (inputRecordData._destroy !== 1) {
        return (<tr key={idx}>
          <td>
            <Input id={`wps-base-materials-drawing-no-${idx}`}
              name="drawing_symbol"
              value={inputRecordData.drawing_symbol || ''}
              onChange={(e) => {
                let newValue = this.props.value
                newValue[idx].drawing_symbol = e.target.value
                this.props.valueChangeFunction(newValue)
              }
              }
            />
          </td>
          <td>
            <CreatableSelect id={`wps-base-materials-product-type-${idx}`}
              options={this.props.product_type_dict.map(item => ({ id: item.id, name: `${item.name} - ${item.description}` }))}
              valueKey="id"
              value={inputRecordData.product_type}
              multi={false}
              creatable={false}
              valueChangeFunction={this.handleValueChangeFunction(idx, 'product_type')}
            />
          </td>
          <td>
            <CreatableSelect id="select-base-material-standardization-wps-form"
              options={this.state.base_materials_standardizations_dict}
              valueKey="name"
              value={this.state.standardizations[idx]}
              multi={false}
              creatable={false}
              valueChangeFunction={(val) => {
                let newStandardizations = this.state.standardizations
                newStandardizations[idx] = val && val.name
                this.setState({ standardizations: newStandardizations })
              }} />
          </td>
          <td>
            <InputGroup>
              <div style={{ width: '95%' }}>
                <CreatableSelect
                  options={this.props.base_material_dict.filter(obj => obj.standardization === this.state.standardizations[idx])}
                  valueKey="id"
                  value={inputRecordData.base_material}
                  multi={false}
                  creatable={false}
                  valueChangeFunction={this.handleValueChangeFunction(idx, 'base_material')}
                />
              </div>
              {/* <InputGroupAddon addonType='append'>
                <button
                  className="small-plus-btn"
                  title="Add new base material"
                  onClick={(e) => {
                    e.preventDefault()
                    this.setState({ base_material_modal_idx: idx })
                  }}><i className="fa fa-plus fa-xs" />
                </button>
              </InputGroupAddon> */}
            </InputGroup>
          </td>
          <RangeInputInfinity uniqId={`thickness_${idx}`}
            value={inputRecordData.thickness}
            invalid={validationErrors.thickness}
            valueChangeFunction={this.handleValueChangeFunction(idx, 'thickness')}
          />
          <RangeInputInfinity uniqId={`throat_thickness_${idx}`}
            value={inputRecordData.throat_thickness}
            invalid={validationErrors.throat_thickness}
            valueChangeFunction={this.handleValueChangeFunction(idx, 'throat_thickness')}
          />
          <RangeInputInfinity uniqId={`diameter_${idx}`}
            value={inputRecordData.diameter}
            invalid={validationErrors.diameter}
            valueChangeFunction={this.handleValueChangeFunction(idx, 'diameter')}
          />
          <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <Button size="sm" color="danger" title="Remove" onClick={() => { this.handleRemoveDynamicInput(idx, inputRecordData.id) }}>
              <i className="fa fa-minus" />
            </Button>
          </td>
        </tr>)
      } else {
        return null
      }
    })
  }

  render() {
    return (
      <div>
        {typeof (this.state.base_material_modal_idx) === 'number' &&
          <BaseMaterialModal
            standardizationDict={this.state.base_materials_standardizations_dict}
            onCancel={() => this.setState({ base_material_modal_idx: null })}
            afterSubmit={this.setBaseMaterial}
          />}
        <Table className="table-center inputs-bottom-border-only" size="sm">
          <thead className="thead-light">
            <tr>
              <th colSpan={10}>
                <Button color="primary" size="sm" style={{ float: 'left' }} onClick={this.handleAddDynamicInput}>
                  <i className="fa fa-plus" /> Add
                </Button>
                <h3>WPS Parent Materials</h3>
              </th>
            </tr>
            <tr>
              <th rowSpan={2}><b>Draft symbol</b></th>
              <th style={{ width: '10%' }} rowSpan={2}><b>Product type</b></th>
              <th style={{ width: '10%' }} rowSpan={2}><b>Standardization</b></th>
              <th style={{ width: '30%' }} rowSpan={2}><b>Base material</b></th>
              <th colSpan={2}>
                <b>Thickness [mm]</b>
                <br />
                <Button color="secondary" size="sm" onClick={this.copyInfinity} title="Copy infinity symbol" >copy  ∞ </Button>
              </th>
              <th colSpan={2}>
                <b>Throat thickness [mm]</b>
                <br />
                <Button color="secondary" size="sm" onClick={this.copyInfinity} title="Copy infinity symbol" >copy  ∞ </Button>
              </th>
              <th colSpan={2}><b>Diameter [mm]</b>
                <br />
                <Button color="secondary" size="sm" onClick={this.copyInfinity} title="Copy infinity symbol" >copy  ∞ </Button>
              </th>
              <th rowSpan={2}>Remove</th>
            </tr>
            <tr>
              <th>min</th>
              <th>max</th>
              <th>min</th>
              <th>max</th>
              <th>min</th>
              <th>max</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRows()}
          </tbody>
        </Table>
      </div>
    )
  }
}

export default WpsBaseMaterialsForm



// WEBPACK FOOTER //
// ./src/components/Wps/WpsBaseMaterialsForm.js